import * as React from 'react';
import MUICheckbox from '@mui/material/Checkbox';

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const Checkboxes = () => {
    return (
        <div>
            <MUICheckbox {...label} defaultChecked />
            <MUICheckbox {...label} />
        </div>
    );
}
export default Checkboxes;